var map = {
	"./AdGuardDnsInfo.vue": [
		"f258",
		"chunk-73f4d9da"
	],
	"./AdGuardFilterStatus.vue": [
		"6750",
		"chunk-4604bada"
	],
	"./AdGuardStats.vue": [
		"4aa6",
		"chunk-50f31ec3",
		"chunk-3cd0212c"
	],
	"./AdGuardTopDomains.vue": [
		"72ed",
		"chunk-2fd6b0ff"
	],
	"./AnonAddy.vue": [
		"a492",
		"chunk-18a1a231"
	],
	"./Apod.vue": [
		"64ab",
		"chunk-aa26a5a6"
	],
	"./BlacklistCheck.vue": [
		"b5ef",
		"chunk-561e4e47"
	],
	"./Blank.vue": [
		"c16a",
		"chunk-2ceb484c"
	],
	"./Clock.vue": [
		"5e2a",
		"chunk-3dc9aafb"
	],
	"./CodeStats.vue": [
		"d7a5",
		"chunk-50f31ec3",
		"chunk-665346fe"
	],
	"./CovidStats.vue": [
		"714f",
		"chunk-50f31ec3",
		"chunk-347afe35"
	],
	"./CryptoPriceChart.vue": [
		"679e",
		"chunk-50f31ec3",
		"chunk-48dc0af1"
	],
	"./CryptoWatchList.vue": [
		"c772",
		"chunk-0b83a9c0"
	],
	"./CustomSearch.vue": [
		"8e89",
		"chunk-498a6a74"
	],
	"./CveVulnerabilities.vue": [
		"c632",
		"chunk-e982c9aa"
	],
	"./DomainMonitor.vue": [
		"3bae",
		"chunk-281d1ad6"
	],
	"./DroneCi.vue": [
		"ebe5",
		"chunk-54f42bec"
	],
	"./EmbedWidget.vue": [
		"ec79",
		"chunk-e80d132e"
	],
	"./EthGasPrices.vue": [
		"91f0",
		"chunk-50f31ec3",
		"chunk-970bec2e"
	],
	"./ExchangeRates.vue": [
		"a65f",
		"chunk-6642b5fb"
	],
	"./Flights.vue": [
		"a75b",
		"chunk-ee1427b4"
	],
	"./GitHubProfile.vue": [
		"e160",
		"chunk-0eec46d7"
	],
	"./GitHubTrending.vue": [
		"3134",
		"chunk-670b2b86"
	],
	"./GlAlerts.vue": [
		"6193",
		"chunk-1891248e"
	],
	"./GlCpuCores.vue": [
		"3237",
		"chunk-1421ee6e"
	],
	"./GlCpuGauge.vue": [
		"9304",
		"chunk-2af23fa2"
	],
	"./GlCpuHistory.vue": [
		"0949",
		"chunk-50f31ec3",
		"chunk-4469b1ce"
	],
	"./GlCpuTemp.vue": [
		"6134",
		"chunk-4b82d385"
	],
	"./GlDiskIo.vue": [
		"35a8",
		"chunk-20617cc5"
	],
	"./GlDiskSpace.vue": [
		"1f55",
		"chunk-48c646f4"
	],
	"./GlIpAddress.vue": [
		"82d1",
		"chunk-b9c87810"
	],
	"./GlLoadHistory.vue": [
		"ce80",
		"chunk-50f31ec3",
		"chunk-3190e50d"
	],
	"./GlMemGauge.vue": [
		"2af9",
		"chunk-00c7add2"
	],
	"./GlMemHistory.vue": [
		"dccf",
		"chunk-50f31ec3",
		"chunk-29a55678"
	],
	"./GlNetworkInterfaces.vue": [
		"4558",
		"chunk-519b296d"
	],
	"./GlNetworkTraffic.vue": [
		"bf13",
		"chunk-50f31ec3",
		"chunk-b8d94e6a"
	],
	"./GlSystemLoad.vue": [
		"7ce6",
		"chunk-50f31ec3",
		"chunk-aeec6e38"
	],
	"./GluetunStatus.vue": [
		"4841",
		"chunk-16fafdd6"
	],
	"./HealthChecks.vue": [
		"dac2",
		"chunk-39b4300f"
	],
	"./IframeWidget.vue": [
		"2386",
		"chunk-5c881d3a"
	],
	"./ImageWidget.vue": [
		"2356",
		"chunk-798b36b6"
	],
	"./Jokes.vue": [
		"7b50",
		"chunk-897867a6"
	],
	"./Linkding.vue": [
		"7b54",
		"chunk-16fb7402"
	],
	"./MullvadStatus.vue": [
		"1e8e",
		"chunk-0ecb0016"
	],
	"./Mvg.vue": [
		"c9a3",
		"chunk-244071ea"
	],
	"./MvgConnection.vue": [
		"ba75",
		"chunk-9d6ae95e"
	],
	"./NdCpuHistory.vue": [
		"e641",
		"chunk-50f31ec3",
		"chunk-71fd7141"
	],
	"./NdLoadHistory.vue": [
		"47ad",
		"chunk-50f31ec3",
		"chunk-a08d5c64"
	],
	"./NdRamHistory.vue": [
		"1afb",
		"chunk-50f31ec3",
		"chunk-1c683ba0"
	],
	"./NewsHeadlines.vue": [
		"f406",
		"chunk-3529e93a"
	],
	"./NextcloudNotifications.vue": [
		"f48c",
		"chunk-df3fe5d2"
	],
	"./NextcloudPhpOpcache.vue": [
		"8eac",
		"chunk-3d711139"
	],
	"./NextcloudStats.vue": [
		"f9cc",
		"chunk-62ffdd45"
	],
	"./NextcloudSystem.vue": [
		"2f96",
		"chunk-50f31ec3",
		"chunk-8469520c"
	],
	"./NextcloudUser.vue": [
		"f298",
		"chunk-d80b5f5e"
	],
	"./NextcloudUserStatus.vue": [
		"2937",
		"chunk-226d0626"
	],
	"./PiHoleStats.vue": [
		"3ce5",
		"chunk-50f31ec3",
		"chunk-4c1ff61e"
	],
	"./PiHoleTopQueries.vue": [
		"7309",
		"chunk-20fd6e9e"
	],
	"./PiHoleTraffic.vue": [
		"e61b",
		"chunk-50f31ec3",
		"chunk-2d225b78"
	],
	"./Proxmox.vue": [
		"8715",
		"chunk-14f1ab23"
	],
	"./PublicHolidays.vue": [
		"79b9",
		"chunk-7a63c006"
	],
	"./PublicIp.vue": [
		"4f0c",
		"chunk-836a18b0"
	],
	"./RssFeed.vue": [
		"4f87",
		"chunk-7f1caab4"
	],
	"./Sabnzbd.vue": [
		"2e26",
		"chunk-4067ed9c"
	],
	"./SportsScores.vue": [
		"7fa8",
		"chunk-1a27104a"
	],
	"./StatPing.vue": [
		"d71a",
		"chunk-fea8d35a"
	],
	"./StockPriceChart.vue": [
		"b1f5",
		"chunk-50f31ec3",
		"chunk-1ec1b1aa"
	],
	"./SynologyDownload.vue": [
		"5a4b",
		"chunk-9dc5304c"
	],
	"./SystemInfo.vue": [
		"0021",
		"chunk-50f31ec3",
		"chunk-3838f3ce"
	],
	"./TflStatus.vue": [
		"5d62",
		"chunk-2ee06ca8"
	],
	"./WalletBalance.vue": [
		"6d7b",
		"chunk-c09b24c2"
	],
	"./Weather.vue": [
		"048f",
		"chunk-2a54cb84"
	],
	"./WeatherForecast.vue": [
		"d76f",
		"chunk-5b26620e"
	],
	"./WidgetBase.vue": [
		"2955"
	],
	"./XkcdComic.vue": [
		"a2e3",
		"chunk-3ea0e802"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "50ed";
module.exports = webpackAsyncContext;